import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { builderDispatch, WebUI } from '../_utils/ui';
import startSessionTimeout from "../_utils/tools/session-timeout";
import SignedInMenu from './signed-in-menu';
import GuestMenu from './guest-menu';
import DropDown from '../_common/dropdown';

// -----------------------------------------------------------
export default class Login extends React.PureComponent {
  dispatches = {
    [WebUI.LOGIN]: () => {
      const loggedIn = App.order.logged_in();

      if (loggedIn) {
        startSessionTimeout();
      }

      this.setState({
        loggedIn,
        storageProviderPresent: App.order.storage_provider_activated()
      });
    }
  }

  constructor(props) {
    super(props);

    this.state = {
      loggedIn: App.order.logged_in(),
      storageProviderPresent: App.order.storage_provider_activated()
    };
  }

  componentDidMount() {
    this.builderDispatchToken = builderDispatch.register(payload => {
      const callback = this.dispatches[payload.type];
      if (callback) {
        callback(payload);
      }
    });
  }

  componentWillUnmount() {
    builderDispatch.unregister(this.builderDispatchToken);
  }

  render() {
    const { className, isEditingSlot, handleClick } = this.props;
    const { loggedIn, storageProviderPresent } = this.state;

    return (
      <div
        className={
          classNames(
            'user-account-menu', className,
            { 'signed-in': loggedIn }
          )
        }
        data-test-id="login-container"
      >
        <DropDown
          id='login-status-menu'
          menuId='login-status-menu'
          label='Your Photo Account'
          buttonText={loggedIn ? App.order.logged_in_user_name : 'Sign in'}
          disabled={isEditingSlot}
          onClick={handleClick}
        >
          {loggedIn ? <SignedInMenu storageProviderPresent={storageProviderPresent} /> : <GuestMenu />}
        </DropDown>
      </div>
    );
  }
}

Login.propTypes = {
  className: PropTypes.string,
  isEditingSlot: PropTypes.bool,
  handleClick: PropTypes.func
}

Login.defaultProps = {
  className: null,
  isEditingSlot: false,
  handleClick: null
}
